let _state = { open: false, sections: [], active: null };
let _onSelect = null;
const _subs = new Set();

export function subscribeNav(fn) {
  _subs.add(fn);
  fn(_state);
  return () => { _subs.delete(fn); };
}

export function publishNav(next) {
  _state = { ..._state, ...next };
  _subs.forEach(fn => fn(_state));
}

export function getNav() {
  return _state;
}

export function registerSelect(fn) {
  _onSelect = fn;
}

export function selectSection(key) {
  if (_onSelect) _onSelect(key);
}
